import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnauthorizedComponent } from './unauthorized.component';
import { RouterModule } from '@angular/router';
import { appRoutes } from './unauthorized.routing';
import { SharedModule } from '../shared/shared.module';
import { TranslateService } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,  
    SharedModule,
    RouterModule.forChild(appRoutes),

  ],
  declarations: [UnauthorizedComponent]
})
export class UnauthorizedModule { 
  
  constructor( translate:TranslateService) {}
}
